(function () {
	function initOffersCarousel() {
		new Glide(
			'.sys__offers-carousel',
			{
				type: 'carousel',
				autoplay: false,
				perView: 4,
				perTouch: 4,
				classes: {
					activeNav: 'now-from-home__offers-bullet--current'
				},
				breakpoints: {
					1039: {perView: 3, perTouch: 3},
					799: {perView: 2, perTouch: 2},
					320: {perView: 1, perTouch: 1}
				}
			}
		).mount()
	}
	
	function initMainBannersCarousel() {
		new Glide(
			'.sys__main-banners',
			{
				type: 'carousel',
				autoplay: 5000,
				perView: 1,
				perTouch: 1,
				gap: 0,
			}
		).mount();
	}

	document.addEventListener('DOMContentLoaded', function () {
		initMainBannersCarousel();
		// initOffersCarousel();
	});
})();
